import { Component, OnInit } from "@angular/core";
import { SettingsService } from "./site-settings.service";
import { ForestDto, SiteSettingsDto } from "@system-shared/classes.dto";
import { ForestsService } from "app/forests/services/forests.service";
import { environment as envQA } from "../../environments/environment.qa";
import { environment as envDev } from "../../environments/environment.dev";
import { environment } from "../../environments/environment";

@Component({
    selector: "app-admin-settings",
    templateUrl: "./site-settings.component.html",
    styleUrls: ["./site-settings.component.scss"],
    standalone: false
})
export class SiteSettingsComponent implements OnInit {
  settings: SiteSettingsDto[] = [];
  modifiedSettings: SiteSettingsDto[] = [];
  forests: ForestDto[] = [];
  modifiedForests: ForestDto[] = [];
  spinner: boolean = false;
  saveSuccessful: boolean = false;
  saveFailed: boolean = false;
  private timeOutId: any;
  dbResults: string;
  showDevReset: boolean = false;
  dbAction: string = '';


  constructor(
    private readonly settingsService: SettingsService,
    private readonly forestsService: ForestsService,
  ) {}

  ngOnInit() {
    this.spinner = true;
    this.getSiteSettings();
    this.getForests();

  }

  getSiteSettings(): void {
    this.settingsService.getSiteSettings().subscribe((data: SiteSettingsDto[]) => {
        this.settings = data;
        this.cloneSettings();
        this.spinner = false;
      });
  }

  getForests(): void {
    this.forestsService.getAllByAdmin().subscribe((data: ForestDto[]) => {
      this.forests = data;
      this.cloneForests();
      this.spinner = false;
    })
  }

  onSiteSettingChange(event: Event, setting: SiteSettingsDto): void {
    setting.enabled = event.target["checked"];
  }

  onForestStatusChange(event: Event, forest: ForestDto): void {
    forest.active = event.target["checked"];
  }

  saveSiteSettings() {
    this.spinner = true;
    this.settingsService.saveSiteSettings(this.modifiedSettings).subscribe((data: SiteSettingsDto[]) => {
        this.settings = data;
        this.cloneSettings();
        this.spinner = false;
        this.displaySuccessfulSaveMessage();
      }, (error) => {
        this.displayErrorOnSaveMessage();
        this.spinner = false;
      });
  }

  saveForestActiveStatus() {
    this.spinner = true;
    this.forestsService.saveForestActiveStatus(this.modifiedForests).subscribe((data: ForestDto[]) => {
      this.forests = data;
      this.cloneForests();
      this.spinner = false;
      this.displaySuccessfulSaveMessage();
    }, (error) => {
      this.displayErrorOnSaveMessage();
        this.spinner = false;
    });
  }

  resetSiteSettings() {
    this.cloneSettings();
  }

  resetForests() {
    this.cloneForests();
  }

  private cloneSettings(): void {
    this.modifiedSettings = JSON.parse(JSON.stringify(this.settings));
  }

  private cloneForests(): void  {
    this.modifiedForests = JSON.parse(JSON.stringify(this.forests));
  }

  private displaySuccessfulSaveMessage() {
    this.saveSuccessful = false;
    if (this.timeOutId) {
      clearTimeout(this.timeOutId);
    }
    this.saveSuccessful = true;
    this.timeOutId = setTimeout(() => {
      this.saveSuccessful = false;
    }, 3000);
  }

  private displayErrorOnSaveMessage() {
    this.saveFailed = false;
    if (this.timeOutId) {
      clearTimeout(this.timeOutId);
    }
    this.saveFailed = true;
    this.timeOutId = setTimeout(() => {
      this.saveFailed = false;
    }, 3000);
  }

  isDbActionAllowed() {
    return [envQA.envName, envDev.envName, 'local'].includes(environment.envName)
  }

  devReset() {
    this.spinner = true;
    this.settingsService.devReset().subscribe((data)=> {
      this.dbResults = data;
      this.spinner = false;
    });
  }

  migrate() {
    this.spinner = true;
    this.settingsService.migrate().subscribe((data)=> {
      this.dbResults = data;
      this.spinner = false;
    });
  }
}
